import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import PortalLayout, { card, StateMsg, SearchBar, matchZoek } from '../components/PortalLayout';
export default function Objecten() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [zoek, setZoek] = useState('');
  useEffect(() => {
    api.get('/klantportaal/objecten')
      .then((r) => setItems(r.data.objecten || []))
      .catch(() => setError('Kon objecten niet laden'));
  }, []);
  const [catFilt, setCatFilt] = useState('');
  const cats = [...new Set((items || []).map((o) => o.categorie || 'Overig'))].sort();
  const zichtbaar = (items || [])
    .filter((o) => !catFilt || (o.categorie || 'Overig') === catFilt)
    .filter((o) => matchZoek(zoek, o.naam, o.type, o.locatie, o.serienummer));
  return (
    <PortalLayout titel="Mijn objecten">
      {items && items.length > 0 && (
        <>
        {cats.length > 1 && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
            {cats.map((c) => (
              <div key={c} onClick={() => setCatFilt(catFilt === c ? '' : c)}
                style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13, cursor: 'pointer', fontWeight: 600,
                  background: catFilt === c ? '#00D4AA' : '#fff', color: catFilt === c ? '#fff' : '#64748b',
                  border: '1px solid ' + (catFilt === c ? '#00D4AA' : '#e2e8f0') }}>{c}</div>
            ))}
          </div>
        )}
        <SearchBar value={zoek} onChange={setZoek} placeholder="Zoek wissel, type of plaats..." />
        </>
      )}
      <StateMsg loading={!items && !error} error={error} leeg={items && items.length === 0} leegTekst="Er zijn nog geen objecten geregistreerd." />
      {items && items.length > 0 && (
        <div style={{ color: '#94a3b8', fontSize: 12, marginBottom: 10 }}>{zichtbaar.length} van {items.length}</div>
      )}
      {zichtbaar.map((o) => (
        <Link key={o.id} to={'/object/' + o.id} style={{ ...card, display: 'block', textDecoration: 'none', color: 'inherit' }}>
          <div style={{ fontWeight: 600, color: '#1e293b' }}>{o.naam || 'Object'}</div>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>{[o.type, o.locatie].filter(Boolean).join(' \u00b7 ')}</div>
          {o.serienummer && <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>S/N: {o.serienummer}</div>}
        </Link>
      ))}
    </PortalLayout>
  );
}
